import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {Breadcrumb} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import DynamicTable from "../../components/extras/DynamicTable";
import SaleTotal from "../../components/sales/SaleTotal";
import {dynamicTableList} from "../../actions/DynamicTableDataAction";
import OtherSaleDialog from "../../components/sale/OtherSaleDialog";
import DataService from "../../functions/DataService";
import TipDialog from "../../components/sale/TipDialog";
import QuestionDialog from "../../components/extras/QuestionDialog";
import {showToast} from "../../actions/ToastAction";

class Tips extends Component {
    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Fecha', 'Sucursal', 'Total', 'Acciones'],
                name: 'Propina',
                title: 'Propinas',
                has_actions: true,
                can_add: false,
                pagination: true,
                edit: true,
                delete: true,
                url: 'tips',
                values: ['id', 'amount', 'date', 'branch_office', 'total'],
                component_fields: [{total:SaleTotal}],
                money_fields: ['amount'],
                datetime_fields: ['date'],
                id: 'table_sale_history'
            },
        };
        this.tip_dialog = React.createRef();
        this.delete_dialog = React.createRef();
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'edit'){
            this.tip_dialog.current.handleToggleModal(response.data)
        }else if(response.event === 'delete'){
            this.delete_dialog.current.open('', response.data.id)
        }
    };

    callbackSuccessDialog = () =>{
        this.props.dynamicTableList({'refresh': true})
    }

    delete = (id) => {
        DataService.delete(`tips/${id}`, (res) => {
            if (res.deleted) {
                this.props.showToast({message: 'Propina Borrada!', type: 'success'});
                this.props.dynamicTableList({'refresh': true})
            } else {
                this.props.showToast({message: 'Tenemos un problema!', type: 'error'});
            }
        })
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Quipuu - Propinas</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/sales'>Finanzas</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Propinas</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <TipDialog ref={this.tip_dialog} callbackSuccess={this.callbackSuccessDialog}/>
                <OtherSaleDialog location='sales'/>
                <QuestionDialog ref={this.delete_dialog} message="Borrar esta propina" callbackConfirm={this.delete}/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        other_sale_select: state.get('other_sale_select'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dynamicTableList(data){
            dispatch(dynamicTableList(data))
        },
        showToast(alert) {
            dispatch(showToast(alert));
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Tips));


// WEBPACK FOOTER //
// ./src/containers/sales/Tips.js